
import { useLocalProp } from '@sbvr/composition-helpers';
import baseComponentFactory from './baseComponentFactory';

export default baseComponentFactory({
  name: 'UIInput',
  props: {
    value: {},
    textarea: Boolean,
    height: String,
    defaultMinHeight: Boolean,
  },
  setup (props, { emit }) {
    const internalValue = useLocalProp({ value: props.value }, emit);
    return {
      internalValue,
    };
  },
});
